import React from 'react';
import axios from 'axios';

import { motion } from 'framer-motion';
import { useModal } from '../Components/Modal/ModalContext';
import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import HeadlinePanel from '../Components/HeadlinePanel';
import LoadingLines from '../Components/LoadingLines';
import Loading from '../Components/Loading';
import IconContainer from '../Components/IconContainer';
import { AddNewVerificationCodeComponent } from '../Components/AddNewVerificationCodeComponent';

const Testing = () => {
    const { openModal } = useModal();
    const { openTimeModal } = useTimeModal();

    const [isCardOfCaseModal, setIsCardOfCaseModal] = React.useState(false);
    const [idCaseForModal, setIdCaseForModal] = React.useState('');

    const [contentt, setContentt] = React.useState('');

    const goBackupDB = () => {
        const token = localStorage.getItem('token');
        axios.get('/api/go-backup-db', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            console.log(response.data.message);
        })
        .catch(error => {
            console.error('Ошибка при запуске бэкапа базы данных:', error);
        });
    }

    const [newUserInfo, setNewUserInfo] = React.useState({
        email: '',
        lastname: '',
        firstname: '',
        surname: '',
        gender: '',
        password: '',
    });

    const [loadingButton, setLoadingButton] = React.useState(false);
    const [statusR, setStatusR] = React.useState('');

    const handleRegistrationSubmit = (e) => {
        e.preventDefault();
        setLoadingButton(true);

        axios.post('/api/registration', {
            email: newUserInfo.email,
            lastname: newUserInfo.lastname,
            firstname: newUserInfo.firstname,
            surname: newUserInfo.surname,
            gender: newUserInfo.gender,
            password: newUserInfo.password,
            passwordConfirm: newUserInfo.password,
        })
        .then(response => {
            setStatusR(response.data.message);
        })
        .catch((error) => {
            console.error(error);
            setStatusR(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setLoadingButton(false);
            setTimeout(() => {
                setStatusR('');
            }, 4000);
        })
    };

    return (
        <>
        <div className='mainContainer'>
            <HeadlinePanel label='Тестирование системы' type='На главную' />
            <div className='containerInner'>
                <div className='pageLimiter'>
                    <a className='button' style={{width: 'fit-content'}} onClick={() => openModal('Тест заголовка', 'Тестирование постоянного модального окна')}>Открыть модально окно</a>
                    <a className='button' style={{width: 'fit-content'}} onClick={() => {openTimeModal('Временное модальное окно warning', 'warning');}}>Открыть временное модально окно warning</a>
                    <a className='button' style={{width: 'fit-content'}} onClick={() => {openTimeModal('Временное модальное окно error', 'error');}}>Открыть временное модально окно error</a>
                    <a className='button' style={{width: 'fit-content'}} onClick={() => {openTimeModal('Временное модальное окно success', 'success');}}>Открыть временное модально окно success</a>
                    <a className='button' style={{width: 'fit-content'}} onClick={() => {openTimeModal('Слово', 'success');}}>Открыть временное модальное окно success с малым содержимым</a>


                    <div className='panel'>
                        <div className='panelHeader'>
                            <h3>Создание учетной записи</h3>
                        </div>
                        <input
                            type='email'
                            value={newUserInfo.email}
                            onChange={(e) => setNewUserInfo((prev) => ({
                                ...prev,
                                email: e.target.value,
                            }))}
                            placeholder='Введите email'
                            minLength='3'
                            maxLength='100'
                            required
                        />
                        <input
                            type='text'
                            value={newUserInfo.lastname}
                            onChange={(e) => setNewUserInfo((prev) => ({
                                ...prev,
                                lastname: e.target.value,
                            }))}
                            placeholder='Введите фамилию'
                            minLength='3'
                            maxLength='100'
                            required
                        />
                        <input
                            type='text'
                            value={newUserInfo.firstname}
                            onChange={(e) => setNewUserInfo((prev) => ({
                                ...prev,
                                firstname: e.target.value,
                            }))}
                            placeholder='Введите имя'
                            minLength='4'
                            maxLength='180'
                            required
                        />
                        <input
                            type='text'
                            value={newUserInfo.surname}
                            onChange={(e) => setNewUserInfo((prev) => ({
                                ...prev,
                                surname: e.target.value,
                            }))}
                            placeholder='Введите отчество'
                            maxLength='180'
                        />

                        <div className='radioSwitchWrapper'>
                            <label className={`radioSwitchLabel ${newUserInfo.gender === 'Муж' ? 'selected' : ''}`}>
                                <input
                                    type='radio'
                                    name='typeSelector'
                                    value='Муж'
                                    checked={newUserInfo.gender === 'Муж'}
                                    onChange={(e) => setNewUserInfo((prev) => ({
                                        ...prev,
                                        gender: e.target.value,
                                    }))}
                                />
                                <span>Мужской</span>
                            </label>
                            <label className={`radioSwitchLabel ${newUserInfo.gender === 'Жен' ? 'selected' : ''}`}>
                                <input
                                    type='radio'
                                    name='typeSelector'
                                    value='Жен'
                                    checked={newUserInfo.gender === 'Жен'}
                                    onChange={(e) => setNewUserInfo((prev) => ({
                                        ...prev,
                                        gender: e.target.value,
                                    }))}
                                />
                                <span>Женский</span>
                            </label>
                        </div>

                        <input
                            type='text'
                            value={newUserInfo.password}
                            onChange={(e) => setNewUserInfo((prev) => ({
                                ...prev,
                                password: e.target.value,
                            }))}
                            placeholder='Введите пароль'
                            minLength='4'
                            maxLength='180'
                            required
                        />

                        {statusR}
                        {loadingButton ? <Loading type='inline' />
                        :
                        <button 
                            className='button maxWidth' 
                            onClick={handleRegistrationSubmit}
                        >
                            Зарегистрировать
                        </button>}

                    </div>

                    <button
                        type='button'
                        className='glassButton'
                    >
                        Новая экспериментальная кнопка
                    </button>
                    
                    <IconContainer />

                    <AddNewVerificationCodeComponent />

                    <button className='button' onClick={() => goBackupDB()}>Создать бэкап</button>

                    <div><h2>Тестовая разметка писем</h2></div>
                    <div style={{margin: '10px 0', backgroundColor: '#F5F8FA'}}>
                        <div style={{width: '440px', backgroundColor: 'white', padding: '0 20px', margin: '0 auto', boxSizing: 'border-box'}}>
                            <div style={{padding: '24px 0'}}>
                                <img style={{height: '40px'}} src='/img/logo/mainlogo-without-text-375.png' alt='ЛК СОАУ Альянс' />
                            </div>
                            <div style={{}}>
                                <h1 style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '24px'}}>Ваша кандидатура направлена аппаратом СРО для утверждения в Арбитражный суд.</h1>
                            </div>
                            <div style={{display: 'flex', flexDirection: 'column', margin: '12px 0'}}>
                                <h2 style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '16px'}}>Вы прикреплены в системе к делу #А32904/83/02</h2>
                            </div>
                            <div style={{display: 'flex', flexDirection: 'column', margin: '12px 0'}}>
                                <div style={{display: 'flex', justifyContent: 'space-between', margin: '5px 0 5px 0'}}>
                                    <h2 style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '16px'}}>Краткая информация:</h2>
                                </div>
                                <div style={{display: 'flex', justifyContent: 'space-between', margin: '5px 0 5px 0'}}>
                                    <h2 style={{width: '40%', fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '15px'}}>Должник</h2>
                                    <a style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '15px'}}>Praha, Česká republika</a>
                                </div>
                                <div style={{display: 'flex', justifyContent: 'space-between', margin: '5px 0 5px 0'}}>
                                    <h2 style={{width: '40%', fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '15px'}}>Комментарий от СРО</h2>
                                    <a style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '15px'}}>Отсутствует</a>
                                </div>
                                <div style={{display: 'flex', justifyContent: 'space-between', margin: '5px 0 5px 0'}}>
                                    <h2 style={{width: '40%', fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '15px'}}>Местоположение*</h2>
                                    <a style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '15px'}}>Praha, Česká republika</a>
                                </div>
                            </div>
                            <div style={{display: 'flex', flexDirection: 'column', margin: '12px 0'}}>
                                <div style={{display: 'flex', justifyContent: 'space-between', margin: '5px 0 10px 0'}}>
                                    <a style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '15px'}}>Теперь есть возможность управлять ведением дела в системе по кнопке ниже.</a>
                                </div>
                            </div>
                            <div style={{display: 'flex', flexDirection: 'column', margin: '12px 0'}}>
                                <h2 style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '16px'}}>Если вы считаете это действие ошибочным</h2>
                                <div style={{display: 'flex', justifyContent: 'space-between', margin: '5px 0 10px 0'}}>
                                    <a style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '15px'}}>свяжитесь с аппаратом СРО</a>
                                </div>
                            </div>
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '12px 0'}}>
                                <a style={{padding: '5px 20px', backgroundColor: 'black', color: 'white', fontSize: '15px', fontWeight: '600', cursor: 'pointer', borderRadius: '3px'}}>Перейти</a>
                            </div>
                            <div style={{padding: '30px 0', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                <a style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '12px', color: '#8899a6', textAlign: 'center'}}>Это сообщение о важных событиях в вашей учётной записи Личного кабинета Альянс.</a>
                                <a style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '12px', color: '#8899a6', textAlign: 'center'}}>Вы можете отказаться от уведомлений в настройках.</a>
                                <a style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '12px', color: '#8899a6', textAlign: 'center'}}>© 2025 юр.инфо</a>
                            </div>
                        </div>
                    </div>
                    <div class="glow-effect">
                        Это объект с анимацией тени
                    </div>
                    <LoadingLines />
                    <Loading />
                    <div className='skeletonBox'></div>


                    <div style={{boxShadow: '0 0 0 1px #e5e5e5', padding: '10px', borderRadius: '.5em', margin: '10px 0'}}>
                        <a className='button' onClick={() => {setContentt('Lorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis pariatur placeat sunt porro hic? Cum id at atque, nulla officiis deserunt nobis ipsam, magni, sit dolorem esse ipsa eveniet reprehenderit. LoremLorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis pariatur placeat sunt porro hic? Cum id at atque, nulla officiis deserunt nobis ipsam, magni, sit dolorem esse ipsa eveniet reprehenderit. LoremLorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis pariatur placeat sunt porro hic? Cum id at atque, nulla officiis deserunt nobis ipsam, magni, sit dolorem esse ipsa eveniet reprehenderit. Lorem')}}>Добавить содержимое</a>
                        <a className='button' onClick={() => {setContentt('')}}>Убрать содержимое</a>
                        <a>Начальный контент</a>
                        <motion.div
                            initial={{ scale: '97%', opacity: 0 }}
                            animate={{ scale: '100%', opacity: 1 }}
                            transition={{ duration: 0.5 }}
                            style={{ overflow: "hidden", background: "#eee" }}
                        >
                            <h1>{contentt}</h1>
                        </motion.div>
                    </div>
                    <motion.div
                        initial={{ scale: '97%', opacity: 0 }}
                        animate={{ scale: '100%', opacity: 1 }}
                        transition={{ duration: 0.5 }}
                        style={{ overflow: "hidden", background: "#eee" }}
                    >
                        <p>Анимированный контент</p>
                    </motion.div>
                    
                    <table className='mainTable'>
                        <thead>
                            <tr>
                                <th>Имя</th>
                                <th>Возраст</th>
                                <th>Город</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td data-label="Имя">Иван</td>
                                <td data-label="Возраст">25</td>
                                <td data-label="Город">Москва</td>
                            </tr>
                            <tr>
                                <td data-label="Имя">Мария</td>
                                <td data-label="Возраст">30</td>
                                <td data-label="Город">Санкт-Петербург</td>
                            </tr>
                            <tr>
                                <td data-label="Имя">Алексей</td>
                                <td data-label="Возраст">28</td>
                                <td data-label="Город">Казань</td>
                            </tr>
                        </tbody>
                    </table>
                    <h1>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis pariatur placeat sunt porro hic? Cum id at atque, nulla officiis deserunt nobis ipsam, magni, sit dolorem esse ipsa eveniet reprehenderit. Lorem</h1>
                    <h1>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis pariatur placeat sunt porro hic? Cum id at atque, nulla officiis deserunt nobis ipsam, magni, sit dolorem esse ipsa eveniet reprehenderit. Lorem</h1>
                    <h1>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis pariatur placeat sunt porro hic? Cum id at atque, nulla officiis deserunt nobis ipsam, magni, sit dolorem esse ipsa eveniet reprehenderit. Lorem</h1>
                </div>
            </div>
        </div>
        </>
    )
}

export default Testing;